// Reusable US Letter (landscape) generic packing list (DOSS PO-v4 design); mapped identity.
// Generated by scripts/wms/generate.ts for PHP-426. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomGenericPackingListFileDataSchema = yup.object().shape({
  customerDisplayName: yup.string().nullable().optional(),
  customerBrandSubtitle: yup.string().nullable().optional(),
  partnerName: yup.string().nullable().optional(),
  poNumber: yup.string().nullable().optional(),
  shipDate: yup.string().nullable().optional(),
  shipFromName: yup.string().nullable().optional(),
  shipFromAddress: yup.string().nullable().optional(),
  shipToName: yup.string().nullable().optional(),
  shipToAddress: yup.string().nullable().optional(),
  shipmentId: yup.string().nullable().optional(),
  carrier: yup.string().nullable().optional(),
  bolNumber: yup.string().nullable().optional(),
  totalPackages: yup.string().nullable().optional(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        sku: yup.string().nullable().optional(),
        partnerItem: yup.string().nullable().optional(),
        upc: yup.string().nullable().optional(),
        description: yup.string().nullable().optional(),
        ordered: yup.string().nullable().optional(),
        shipped: yup.string().nullable().optional(),
        uom: yup.string().nullable().optional(),
        lotExp: yup.string().nullable().optional(),
        packageRef: yup.string().nullable().optional(),
      }),
    )
    .required(),
})

export type BiomGenericPackingListFileData = yup.InferType<
  typeof biomGenericPackingListFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<BiomGenericPackingListFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomGenericPackingListFileMappings: RequiredFileData = {
  customerDisplayName: '6dfc01a5-b07f-46d3-be7d-987810b15e22',
  customerBrandSubtitle: '796f8e1b-7cd3-41f9-8af1-6ad6c564d1e9',
  partnerName: '23e0716a-1ee1-4c22-abad-a78d6994ad7b',
  poNumber: '3e7121c6-0de8-4029-ad7e-790233343939',
  shipDate: '037f26bf-3554-4442-8775-ea7b48a5a117',
  shipFromName: '231a5b93-6f28-40e9-a4ea-dd4674815d23',
  shipFromAddress: '45ae8368-d82c-43e6-bdef-102e5c96e1e0',
  shipToName: '164ee209-b6d2-4833-9ec8-371d211521c8',
  shipToAddress: '1235eeea-22b0-4a07-af16-8a44042e993d',
  shipmentId: 'a7484591-bbbc-4c3b-beca-d6c19305ec27',
  carrier: 'd06d07f3-ed01-4ce5-8d81-189fd010ebb3',
  bolNumber: '7467d45b-35ed-4894-8332-21f5303ba14d',
  totalPackages: '8ccc8b35-8210-4c78-b5e4-18815bb54b1b',
  items: [
    {
      sku: 'c33c3516-7a33-4e54-82fd-ee04289d5973',
      partnerItem: '2300eb48-6e60-4d49-956f-5b76529c0ec6',
      upc: '15755ee4-e73f-4dfe-9cac-4596b427e4c2',
      description: 'dec05fdd-628a-4e49-a9fd-8a6e528a03d1',
      ordered: '995bd8b4-5d81-4660-83bc-784c65a29983',
      shipped: 'fa8adf14-a910-4a0a-a551-63ce76383513',
      uom: '24ea81cf-c179-44cb-94cd-8a51cb1a88ce',
      lotExp: 'c44cbccb-2444-402b-8377-164f0bf9763e',
      packageRef: 'aa5fa571-dbdb-4628-ad5a-1b656a5f4bec',
    },
  ],
}
